import type { FormikProps } from 'formik';

import type { InvestmentSymbolLookupItem } from 'app-components/flux/investment-holdings-v2';
import type { transactionsTypes } from 'app-components/flux/transactions';

export type VirtualCashFlowTxnType = 'VIRTUAL_CASH_FLOW';

export type InvestmentTransactionFormType =
  | NonNullable<transactionsTypes.TransactionProps['investmentTxnType']>
  | VirtualCashFlowTxnType
  | '';

export type InvestmentTransactionFormValues = Omit<
  transactionsTypes.TransactionProps,
  'amount' | 'investmentTxnType' | 'postedOn'
> & {
  amount: number;
  investmentTxnType?: InvestmentTransactionFormType | null;
  postedOn: string;
  type: 'CASH_FLOW' | 'INVESTMENT';
  fullSecurity?: InvestmentSymbolLookupItem;
};

export type InvestmentTransactionFormik = FormikProps<InvestmentTransactionFormValues>;

export type InvestmentTransactionFormikProps = {
  formik: InvestmentTransactionFormik;
};

export const toTransactionProps = (values: InvestmentTransactionFormValues): transactionsTypes.TransactionProps => {
  const { fullSecurity: _fullSecurity, investmentTxnType, ...transactionValues } = values;

  return {
    ...transactionValues,
    investmentTxnType: investmentTxnType === 'VIRTUAL_CASH_FLOW' ? undefined : investmentTxnType,
  };
};
